import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import environment from '@environment';
import { Button } from 'components/buttons/button';
import { PopupStore } from 'components/popup/popup.store';
import { AppContext } from 'core/context/app.context';
import { SitePlatform } from 'core/enums/site-platform';
import { AuthUtils } from 'core/stores/auth/auth-utils';
import { SiteConfigStore } from 'core/stores/site-config.store';
import { Util } from 'utils/common.utils';
import styles from './brand-miss-match.module.scss';

const BrandMissMatch = observer(({ popupStore }: { popupStore: PopupStore }) => {
  const { authStore, platform } = useContext(AppContext);
  const { t } = useTranslation();
  const logo =
    platform === SitePlatform.gotv ? 'logos/gotv-brand-colour-logo.png' : 'logos/dstv-d-shaped-logo-blue.png';

  const onContinue = () => {
    const { accessToken, idToken } = AuthUtils.GetStoredAuth();
    const provider = AuthUtils.GetStoredAuthProvider();
    const basePath =
      platform === SitePlatform.gotv
        ? `${environment.GOTV_REDIRECT_URL_BASE}${environment.GOTV_REDIRECT_URL_QUERY_PARAMS}`
        : `${environment.DSTV_REDIRECT_URL_BASE}${environment.DSTV_REDIRECT_URL_QUERY_PARAMS}`;

    const path = `${basePath}`
      .replace('{culture}', Util.LocaleFromUrl())
      .replace('{accessToken}', `${accessToken}`)
      .replace('{idToken}', `${idToken}`)
      .replace('{provider}', `${provider}`);

    authStore.logout();
    SiteConfigStore.reset();

    window.open(path, '_self');
  };

  return (
    <div className={styles.popupContainer}>
      <div>
        <div className={clsx(styles.content, 'text-center')}>
          <img className={clsx(styles.logo, 'cust-mb-4')} src={Util.GetImageAsset(logo)} alt="" />

          <h3 className="cust-mb-2">{t('brandMissMatchPopup.header', { brand: platform })}</h3>
          <p className="cust-mb-2">{t('brandMissMatchPopup.note', { brand: platform })}</p>
          <p className="text-bold cust-mb-4">{t('brandMissMatchPopup.action')}</p>

          <Button onClick={onContinue}>{t('buttons.continue')}</Button>
        </div>
      </div>
    </div>
  );
});

export default BrandMissMatch;